import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styles from "./CKYCVerification.module.scss";
import AfterOnboardAPI from "../../services/AfterOnboardAPI";
import { handlehideContextualLoader, handleShowContextualLoader } from "../../utils/contextualLoaderTrigger";
import Swal from "sweetalert2";
import CkycOTPModal from "./components/CkycOTPModal";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";

export default function CKYCVerification() {
  const [data, setData] = useState(null);
  const [openCkyc, setOpenCkyc] = useState(false);
  const [ckycTransactionId, setCkycTransactionId] = useState("");
  const [isAuthorized, setIsAuthorized] = useState(true);

  const { accountId } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const { ckycInitiateAPI } = new AfterOnboardAPI();

  useEffect(() => {
    const fetchAPI = async () => {
      handleShowContextualLoader();
      try {
        const { customerDetailsAPI } = new AfterOnboardAPI();
        const res = await customerDetailsAPI();
        setData(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        handlehideContextualLoader();
      }
    };

    fetchAPI();
  }, []);

  const handleContinue = async () => {
    handleShowContextualLoader();

    try {
      const res = await ckycInitiateAPI(accountId, isAuthorized);

      if (res?.data?.data?.isCkycFlow || res?.data?.isCkycFlow) {
        setOpenCkyc(true);
        setCkycTransactionId(res?.data?.data?.data?.transactionID);
      } else {
        navigate("/ckyc-initiate-failed");
      }
    } catch (error) {
      console.error("Initiate CKYC error:", error);
      if (error?.response?.data?.data?.redirectFailureScreen) {
        navigate("/ckyc-verification-failed", { state: error?.response?.data?.message });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error?.response?.data?.message || "Something went wrong",
        });
      }
    } finally {
      handlehideContextualLoader();
    }
  };

  return (
    <>
      <div className={`${styles.container} wrapper auto-height`}>
        <div className={styles.content}>
          {/* Header */}
          <div className={styles.header}>
            <h1>Fetch Your CKYC</h1>
            <p>We will securely retrieve your CKYC record from CERSAI and auto-fill your details.</p>
          </div>

          {/* CKYC Details */}
          <div className={styles.details}>
            {/* PAN Number */}
            <div className={styles.formGroup}>
              <label htmlFor="panNumber">PAN Number</label>

              <input id="panNumber" value={data?.pancard ?? ""} placeholder="Enter PAN Number" disabled />
            </div>

            {/* Date of Birth */}
            <div className={`${styles.formGroup} ${styles.dobGroup}`}>
              <label htmlFor="dob">Date of Birth</label>
              <input id="dob" value={data?.dob ? moment(data?.dob).format("DD/MM/YYYY") : ""} placeholder="DD/MM/YYYY" disabled />
            </div>

            {/* Security Info */}
            <div className={styles.securityBox}>
              <div className={styles.icon}>✓</div>
              <div>
                <p className={styles.securityTitle}>Your data is safe and secure</p>
                <p className={styles.securityText}>We only use your information for KYC verification and loan processing.</p>
              </div>
            </div>

            {/* Authorization */}
            <label className={styles.checkboxWrapper}>
              <input type="checkbox" checked={isAuthorized} onChange={(e) => setIsAuthorized(e.target.checked)} />
              <span>I authorize Ram Fincorp to retrieve my CKYC record from CERSAI for the purpose of identity verification.</span>
            </label>
          </div>
        </div>

        {/* Submit Button */}
        <div className={styles.footer}>
          <button type="button" disabled={!isAuthorized} onClick={handleContinue}>
            Fetch My CKYC
          </button>

          <div className={styles.privacyText}>
            <span>🔒</span>
            <span>
              By continuing you agree to our{" "}
              <a className={styles.privacyLink} target="_blank" rel="noopener noreferrer" href={`https://www.ramfincorp.com/privacypolicy/`}>
                Privacy Policy
              </a>
            </span>
          </div>
        </div>
      </div>

      {openCkyc && <CkycOTPModal openCkyc={openCkyc} setOpenCkyc={setOpenCkyc} ckycTransactionId={ckycTransactionId} setCkycTransactionId={setCkycTransactionId} />}
    </>
  );
}
